export const CONTACT_TYPES = [
    { label: "Quote Request", value: "QUOTE_REQUEST" },
    { label: "Contact Request", value: "CONTACT_REQUEST" },
    { label: "Complaint", value: "COMPLAINT" },
    { label: "Compliment", value: "COMPLIMENT" },
    { label: "Employment Inquiry", value: "EMPLOYMENT_INQUIRY" },
    { label: "Question", value: "QUESTION" },
    { label: "Spam", value: "SPAM" },
];

export const URGENCY_LEVELS = [
    { label: "High", value: "HIGH" },
    { label: "Urgent", value: "URGENT" },
    { label: "Normal", value: "NORMAL" },
    { label: "Low", value: "LOW" },
];
